export default __webpack_public_path__ + "static/media/rysk.b35dc24c.webp";